// Smooth-scroll internal anchors, safely handling missing/invalid targets.
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
        anchor.addEventListener('click', (e) => {
            const href = anchor.getAttribute('href') || '';
            if (href === '#' || href.trim() === '') {
                return;
            }

            const hash = href.slice(1);
            if (!hash) {
                return;
            }

            e.preventDefault();

            const selector = `#${CSS.escape(hash)}`;
            const targetElement = document.querySelector(selector);

            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
            }
        });
    });
});